import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { pauseMaintenanceService } from '../../api/maintenance-service.ts';

export default function usePauseMaintenanceService(): UseMutationResult<
  Awaited<ReturnType<typeof pauseMaintenanceService>>,
  Error,
  string
> {
  return useMutation({
    mutationFn: (serviceId: string) => pauseMaintenanceService(serviceId),
  });
}
